import '@shared/infra/translation'
import '@shared/infra/adapters/amplify'
import '@aws-amplify/ui-react/styles.css'
import './styles/global.css'
import './lib/sentry'

import { setDefaultOptions } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import ReactDOM from 'react-dom/client'

import { version as PkgVersion } from '../package.json'
import { enableMSW } from './api/_mocks'
import App from './App'

setDefaultOptions({
  locale: ptBR,
})

localStorage.setItem('version', PkgVersion)

enableMSW().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  )

  return root.render(<App />)
})
